export const colors = {
  background: {
    main: '#FAFAFA',
  },
  black: {
    main: '#000000',
  },
  brown: {
    '10': '#EAE6E7',
    '40': '#AB9D9F',
    '100': '#2C090C',
  },
  darkGrey: {
    '10': '#ECECEC',
    '20': '#D9D9D9',
    '40': '#B3B3B3',
    '60': '#8C8C8E',
    '80': '#666668',
    '90': '#5a5a5a',
    '100': '#404042',
  },
  darkRed: {
    '10': '#F3E8E9',
    '100': '#871722',
  },
  grey: {
    main: '#EDEEEF',
  },
  lightBrown: {
    '100': '#570D13',
  },
  orange: {
    '10': '#FBEFEC',
  },
  red: {
    '10': '#FBE9EC',
    '100': '#D91F3D',
  },
  success: {
    '10': '#EDFAF3',
    '40': '#4CCD88',
  },
  warning: {
    '10': '#FFF3E6',
    '100': '#FF8906',
  },
  white: {
    main: '#FFFFFF',
  },
};
